import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTaskDetails } from "../../../redux/rm-buddies/actions";
import { Segment, Grid, Checkbox } from "semantic-ui-react";
import { statusMapping, statusTagMapping } from "../TasksTabs";
import moment from "moment";
import "./style.less";

const getTaskCategory = task => {
  if (task.status === "CANCELLED") return "CANCELLED";
  if (task.status === "COMPLETE" || task.status === "RMBUDDY_COMPLETE")
    return "RMBUDDY_COMPLETE";
  if (!task.assignedTo) return "UNALLOCATED";
  if (task.status === "PENDING" && moment(task.dueAt) < moment()) {
    return "DELAYED";
  } else if (task.status === "PENDING") {
    return "PENDING";
  }
};
function TaskDetailsPage() {
  const { taskId } = useParams();
  const dispatch = useDispatch();
  const taskDetails = useSelector(({ rmBuddies }) =>
    rmBuddies.taskDetails && rmBuddies.taskDetails.length > 0
      ? rmBuddies.taskDetails[0]
      : null
  );

  useEffect(() => {
    if (taskId) {
      console.log(taskId);
      dispatch(fetchTaskDetails([{ _id: taskId }]));
    }
  }, [dispatch, taskId]);

  return (
    <div className="TaskDetailsPage">
      <Segment loading={!taskDetails ? true : false}>
        {taskDetails && (
          <div>
            <h1>
              Tasks ID: #{taskDetails.taskUniqueId.substring(0, 5)}...
              {taskDetails.taskUniqueId.substring(25)}
            </h1>
            <p className={getTaskCategory(taskDetails)}>
              {statusMapping[getTaskCategory(taskDetails)]}
            </p>
            <br />
            <Grid className="TaskDetailsTable">
              <Grid.Row>
                <Grid.Column width={6}>Task Type:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {" "}
                  {taskDetails.taskType}{" "}
                </Grid.Column>
              </Grid.Row>

              {taskDetails.statusTag && (
                <Grid.Row>
                  <Grid.Column width={6}>Status Tag:</Grid.Column>
                  <Grid.Column width={8} className="bold-font">
                    {statusTagMapping[taskDetails.statusTag]}
                  </Grid.Column>
                </Grid.Row>
              )}

              <Grid.Row>
                <Grid.Column width={6}> Assigned RM Buddy:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {taskDetails.assignedTo
                    ? taskDetails.assignedTo.name
                    : "NULL"}
                  ,
                  {taskDetails.assignedTo &&
                    taskDetails.assignedTo.mobileNumber}{" "}
                </Grid.Column>
              </Grid.Row>
              {taskDetails.assignedUserLog &&
                taskDetails.assignedUserLog.length > 0 && (
                  <Grid.Row>
                    <Grid.Column width={6}> Previous RM Buddy:</Grid.Column>
                    <Grid.Column width={8} className="bold-font">
                      {taskDetails.assignedUserLog[0].rmBuddyId.name},
                      {taskDetails.assignedUserLog[0].rmBuddyId.mobileNumber}
                    </Grid.Column>
                  </Grid.Row>
                )}
              <Grid.Row>
                <Grid.Column width={6}>Buddy Block:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {taskDetails.belongsToBuddyBlock
                    ? taskDetails.belongsToBuddyBlock.properties.name
                    : ""}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6}>Order Number:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {taskDetails.orderNumbers.reduce(
                    (acc, oN) => (acc += `# ${oN}, `),
                    ""
                  )}{" "}
                </Grid.Column>
              </Grid.Row>
              {taskDetails.serviceRequestId && (
                <Grid.Row>
                  <Grid.Column width={6}>Root Service Request Id:</Grid.Column>
                  <Grid.Column width={8} className="bold-font">
                    {taskDetails.serviceRequestId}
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row>
                <Grid.Column width={6}>Customer Name:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {taskDetails.customerInfo.fullName}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6}>Customer Mobile Number:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {taskDetails.customerInfo.mobileNumber}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6}>Due At:</Grid.Column>
                <Grid.Column width={8} className="bold-font">
                  {moment(taskDetails.dueAt).format("YYYY-MM-DD h:mm a")}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <br />
            <br />
            <div className="TaskDetailsChecklist">
              <Checkbox
                readOnly
                label="Society Verification"
                checked={taskDetails.checkList.societyVerification}
              />
              <br />
              <Checkbox
                readOnly
                label="Docs at Delivery"
                checked={taskDetails.checkList.docsAtDelivery}
              />
            </div>
            <br />
          </div>
        )}
      </Segment>
    </div>
  );
}

export default TaskDetailsPage;
